import { Add, RadioButtonChecked, RadioButtonUnchecked, Search } from '@mui/icons-material';
import { Autocomplete, Box, Dialog, DialogActions, DialogContent, TextField, Tooltip } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react'
import hsnData from '../../../../../../data/hsn.json';
import sacData from '../../../../../../data/sac.json'


function HSNSuggest({hsn,setHsn,billingType,setBillingType}) {
    const [dialogStatus, setDialogStatus] = useState();
    const focusInputRef = useRef();

    useEffect(() => {
        if(dialogStatus){
            const timer = setTimeout(() => {
                if (focusInputRef.current) {
                focusInputRef.current.focus();
                }
            }, 100); // Gives the modal/dropdown animation a brief moment to settle
            return () => clearTimeout(timer);
        }
    }, [dialogStatus]);

    return(
        <>
            <Box display="flex" width="100%">
                <TextField value={hsn} onChange={(e)=>setHsn(e.target.value)}
                    label="HSN / SAC" 
                    variant="outlined"
                    fullWidth
                />
                <button className='btn btn-outline-primary' type='button' onClick={()=>setDialogStatus(true)} ><Search /></button>
            </Box>

            <Dialog
                open={dialogStatus}
                keepMounted
                onClose={()=>setDialogStatus(false)}
                maxWidth="md"
                fullWidth={true}
            >
                <DialogContent>

                    <div className='row mt-3'>
                        <div className='col-md-12'>
                            <h5 className='' >Select Inventory Type</h5>
                        </div>
                        <div className='col-md-12'>
                            {billingType==1 ?
                                <button className='btn btn-primary'  ><RadioButtonChecked/> Goods </button>
                                :
                                <button className='btn btn-outline-primary' onClick={()=>setBillingType(1)}><RadioButtonUnchecked/> Goods </button>
                            }
                            {billingType==2 ?
                                <button className='ms-3 btn btn-primary'><RadioButtonChecked/> Services </button>
                                :
                                <button className='ms-3 btn btn-outline-primary' onClick={()=>setBillingType(2)}><RadioButtonUnchecked/>Services  </button>
                            }
                        </div>
                    </div>

                    <div className='row mt-3'>
                        <div className='col-md-12'>
                            <Autocomplete
                                options={billingType == 1 ? hsnData : sacData}
                                getOptionKey={(option) => option.value}
                                onChange={(event, newValue) => {
                                    if(newValue){
                                        setHsn(newValue.value)
                                        setDialogStatus(false);
                                    }
                                }}
                                className='bg-white'
                                renderInput={(params) => <TextField inputRef={focusInputRef}  {...params} size="small" label='Search Item' /> } 
                            />
                        </div>
                    </div>

                </DialogContent>
                <DialogActions>
                    <button className='btn btn-outline-primary' onClick={()=>setDialogStatus(false)}>Cancel</button>
                </DialogActions>


                
            </Dialog>
        </>
    )
}

export default HSNSuggest